var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0207 10.078L13.876 12.9327L12.9327 13.876L10.078 11.0207C9.01587 11.8722 7.69471 12.3353 6.33337 12.3334C3.02137 12.3334 0.333374 9.64537 0.333374 6.33337C0.333374 3.02137 3.02137 0.333374 6.33337 0.333374C9.64537 0.333374 12.3334 3.02137 12.3334 6.33337C12.3353 7.69471 11.8722 9.01587 11.0207 10.078ZM9.68337 9.58337C10.5294 8.7133 11.002 7.54699 11 6.33337C11 3.75471 8.91137 1.66671 6.33337 1.66671C3.75471 1.66671 1.66671 3.75471 1.66671 6.33337C1.66671 8.91137 3.75471 11 6.33337 11C7.54699 11.002 8.7133 10.5294 9.58337 9.68337L9.68337 9.58337V9.58337Z",
    fill: "#03053D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fe060eec8443063059519bae86799c7d.svg";
export { ForwardRef as ReactComponent };